/**
 * Collection FAQ Section — standalone JS
 * Extracted from product-detail.js section17 logic
 * No external dependencies
 */
document.addEventListener('DOMContentLoaded', function () {

    var faqElements = document.querySelectorAll('.collect-faq-item');

    if (!faqElements.length) {
        return; /* section not present on this page */
    }

    /* ----------------------------------------------------------------
     * Toggle helpers
     * ---------------------------------------------------------------- */
    function setOpen(item, isOpen) {
        var question = item.querySelector('.collect-faq-question');

        item.classList.toggle('is-open', isOpen);

        if (question) {
            question.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        }
    }

    /* ----------------------------------------------------------------
     * Bind events
     * ---------------------------------------------------------------- */
    faqElements.forEach(function (item) {
        var question = item.querySelector('.collect-faq-question');

        if (!question) {
            return;
        }

        setOpen(item, false);

        question.addEventListener('click', function () {
            setOpen(item, !item.classList.contains('is-open'));
        });

        question.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                setOpen(item, !item.classList.contains('is-open'));
            }
        });
    });

    /* ----------------------------------------------------------------
     * Shopify section-load re-initialisation
     * ---------------------------------------------------------------- */
    document.addEventListener('shopify:section:load', function (event) {
        var incomingItems = event.target.querySelectorAll('.collect-faq-item');

        if (!incomingItems.length) {
            return;
        }

        incomingItems.forEach(function (item) {
            if (item.dataset.faqInit === 'true') {
                return;
            }

            item.dataset.faqInit = 'true';

            var question = item.querySelector('.collect-faq-question');

            if (!question) {
                return;
            }

            setOpen(item, false);

            question.addEventListener('click', function () {
                setOpen(item, !item.classList.contains('is-open'));
            });

            question.addEventListener('keydown', function (event) {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    setOpen(item, !item.classList.contains('is-open'));
                }
            });
        });
    });

});
